import React from 'react';
import { classNames } from '../../utils/class-names.js';
import { BmUIKitConfig } from '../../utils/config.js';

const Avatar = /*#__PURE__*/ React.forwardRef(({ href, onClick, target, as: Tag = href ? "a" : "span", variant, size, rounded, title, status, src, className, children }, ref)=>{
    const classes = classNames("avatar", status && `avatar-${status}`, size && `avatar-${size}`, className);
    let avatar = "";
    if (!src) {
        const avatarClasses = classNames("avatar-title", rounded ? "rounded" : "rounded-circle", variant && `text-bg-${variant}-soft`);
        avatar = /*#__PURE__*/ React.createElement("div", {
            className: avatarClasses,
            title: title
        }, children || (title || "").split(" ").map((part)=>part.substring(0, 1).toLocaleUpperCase()).join("").substring(0, 2));
    } else {
        const avatarClasses = classNames("avatar-img", rounded ? "rounded" : "rounded-circle");
        avatar = /*#__PURE__*/ React.createElement("img", {
            className: avatarClasses,
            alt: title,
            title: title,
            src: src
        });
    }
    const linkParams = BmUIKitConfig.getOption("customLinkProvider")({
        onClick,
        href,
        target
    });
    return /*#__PURE__*/ React.createElement(Tag, {
        ref: ref,
        className: classes,
        ...linkParams
    }, avatar);
});

export { Avatar };
//# sourceMappingURL=Avatar.js.map
